import React from 'react';

const Loader = () => {
    return (
        <div style={{height: "300px"}} className="d-flex justify-content-center align-items-center">
            <div className="spinner-grow text-primary" role="status" style={{width: "50px", height: "50px", backgroundColor: "#0d6efd"}}>
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
};

export default Loader;